import React from "react";
import { useHistory } from "react-router-dom";
import PriceAndTimeFilter from "./PriceAndTimeFilter";
import TravelInfoCard from "./TravelInfoCard";
import { useSelector } from "react-redux";
import { useDispatch } from "../../../../../utils/react-redux-hooks";
import { useMediaQuery } from "react-responsive";
import TravelCardsFilterSection from "./TravelCardsFilterSection";
import DateTabs from "./DateTabs";
import SearchLanding from "./SearchLanding";

const SearchSectionBody = (props) => {
  // const [isDirect, setIsDirect] = React.useState(true);
  // const [isMidway, setIsMidway] = React.useState(false);
  // const [isDiscount, setIsDiscount] = React.useState(true);

  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });

  const history = useHistory();

  let { state: resState } = useSelector((state) => ({
    state: state.reserve,
  }));

  const dispatch = useDispatch();

  return (
    <div className="mt-5 container" style={{ padding: "0px 4px" }}>
      <div className="d-flex mx-auto" style={{ gap: 8 }}>
        {!isTabletOrMobile && <TravelCardsFilterSection />}

        <div className="col-sm-12 col-lg-9 d-block">
          <DateTabs props={props} />
          <PriceAndTimeFilter />
          <TravelInfoCard data={resState.mockTravels} props={props} />
          <SearchLanding data={resState.mockTravels[0]} />
        </div>
      </div>
    </div>
  );
};

export default SearchSectionBody;
